import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "payments-section mt-2" }
const _hoisted_2 = { class: "payments-card" }
const _hoisted_3 = { class: "payment-icon" }
const _hoisted_4 = { class: "payment-copy" }
const _hoisted_5 = { class: "payment-title" }
const _hoisted_6 = { class: "payment-meta" }
const _hoisted_7 = { class: "payment-amount" }
const _hoisted_8 = { class: "payment-total" }
const _hoisted_9 = { class: "payment-status" }
const _hoisted_10 = { class: "status-label" }

import { computed } from "vue";

type SubscriptionDetailResponse = {
  payments?: {
    amount: number | string | null;
    status: string | null;
    card_brand: string | null;
    card_last4: string | null;
    paid_at: string | null;
  }[];
};


export default /*@__PURE__*/_defineComponent({
  __name: 'SubscriptionDetailPaymentHistoryCard',
  props: {
    detail: {}
  },
  setup(__props: any) {

const props = __props;

function titleCase(value: string | null | undefined) {
  const text = String(value ?? "").trim();
  if (!text) return "Card";
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

function formatPaidAt(value: string | null) {
  if (!value) return "-";
  const date = new Date(value.replace(" ", "T"));
  if (Number.isNaN(date.getTime())) return "-";
  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  }).format(date);
}

function paymentStatusMeta(status: string | null | undefined) {
  const key = String(status ?? "").trim().toLowerCase();
  if (key === "succeeded" || key === "success") return { key: "succeeded", label: "Succeeded" };
  if (key === "failed") return { key: "failed", label: "Failed" };
  return { key: "succeeded", label: titleCase(key || "succeeded") };
}

function formatAmount(amount: number | string | null) {
  const value = Number(amount ?? 0);
  if (Number.isNaN(value)) return "$0.00 USD";
  return `$${value.toFixed(2)} USD`;
}

const paymentItems = computed(() =>
  (props.detail.payments ?? []).map((item) => {
    const meta = paymentStatusMeta(item.status);
    const brand = titleCase(item.card_brand);
    return {
      cardBrand: item.card_brand ?? "",
      amountText: formatAmount(item.amount),
      cardLabel: `${brand} •••• ${item.card_last4 || "----"}`,
      paidAtLabel: formatPaidAt(item.paid_at),
      statusKey: meta.key,
      statusLabel: meta.label,
    };
  }),
);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "payments-section-title px-2" }, "Payment history", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentItems.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "payment-row"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_icon, {
              size: "18",
              color: "success"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("mdi-credit-card-check-outline", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(item.cardLabel), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(item.paidAtLabel), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(item.amountText), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", {
                class: _normalizeClass(["status-dot", `status-dot--${item.statusKey}`])
              }, null, 2),
              _createElementVNode("span", _hoisted_10, _toDisplayString(item.statusLabel), 1)
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})